import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Title = ({ className, children }: Props) => {
    return <div className={cn(className)}>{children}</div>;
};
